import type { DoseProvenance } from '~/domain/projections/views';

export const generateDoseLevelLabel = (
    dose: { displayMaxDoseGy: number; provenance: DoseProvenance } | undefined,
    doseScale: number,
    relativeDoseInPercent?: number
): string | null => {
    if (!dose || !relativeDoseInPercent) {
        return null;
    }

    const maxDosePercentage = relativeDoseInPercent.toFixed(0);
    const maxDoseGy = dose.displayMaxDoseGy.toFixed(1);
    const doseRescaledByValue =
        doseScale !== 1 ? (((doseScale - 1) / 1) * 100).toFixed() : null;

    return dose.provenance === 'predicted' &&
        doseRescaledByValue &&
        parseFloat(doseRescaledByValue) !== 0
        ? `Max: ${maxDosePercentage} % (${maxDoseGy} Gy, scaled by ${doseRescaledByValue} %)`
        : `Max: ${maxDosePercentage} % (${maxDoseGy} Gy)`;
};
